import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import { InboxForMe } from 'owa-inbox-for-me-surface';
import loc from 'owa-localize';
import { loading } from 'owa-locstrings/lib/strings/loading.locstring.json';
import * as React from 'react';
import {
    getStore as getPopoutChildStore,
    PopoutLoadingView,
    PopoutChildState,
} from 'owa-popout-v2';

import styles from 'owa-mail-module-view/lib/components/MailModule.scss';

export default observer(function DeepLinkInboxForMeView() {
    const { state } = getPopoutChildStore();

    const featureEnabled = isFeatureEnabled('inboxForMe-deeplink');
    return state != PopoutChildState.Ready ? (
        <PopoutLoadingView loadingString={loc(loading)} />
    ) : (
        <div className={styles.rightPane}>
            {featureEnabled && (
                <InboxForMe
                    showOnlyUnreadMailMessages={true}
                    loadTeamsChats={true}
                    loadTeamsChannels={false}
                    loadEmails={false}
                />
            )}
        </div>
    );
});
